import type { HttpApiError } from '@backmarket/http-api'
import toastTranslations from '@backmarket/nuxt-layer-buyback/utils/Toast.translations'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import type { PostBuybackListing } from '~/api/quotes/types'

import translations from './useUpdateListings.translations'

export async function useUpdateListings({
  listings,
  productId,
  marketCode,
}: {
  listings: PostBuybackListing[]
  productId: string
  marketCode: string
}): Promise<{
  shouldFetch: boolean
}> {
  const logger = useLogger()
  const i18n = useI18n()
  const { openErrorToast } = useTheToast()
  const $httpFetch = useHttpFetch()

  try {
    const response = await $httpFetch('/buyback-quotes/api/v1/quotes', {
      method: 'POST',
      body: {
        productId,
        marketCode,
        listings,
      },
    })

    // 207 multiple responses
    if (response?.length) {
      const failedListings = response.filter(
        (listing) => listing.status !== 202,
      )

      if (failedListings.length) {
        openErrorToast({
          content: i18n(translations.toastUpdateListingsErrorContent),
          duration: 3000,
        })
      }
    }
  } catch (err) {
    openErrorToast({
      title: i18n(toastTranslations.toastErrorTitle),
      content: i18n(toastTranslations.toastErrorContent),
    })

    logger.error('[BUYBACK][API][QUOTES] Error updating quotes', {
      error: err as HttpApiError,
      owners: ['bot-squad-circularity-offer-front'],
    })
  }

  /* Fetch quotes to update successfully updated listings */
  return {
    shouldFetch: true,
  }
}
